import { useEffect, useState, useRef, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";

const SYMBOLS = ["♪", "♫", "♩", "♬"];
let counter = 0;

export default function NoteCursor() {
  const [notes, setNotes] = useState([]);
  const lastMove = useRef(0);

  const spawn = useCallback((x, y, burst) => {
    const count = burst ? 4 + Math.floor(Math.random() * 3) : 1;
    const batch = [];
    for (let i = 0; i < count; i++) {
      batch.push({
        id: ++counter,
        x,
        y,
        symbol: SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)],
        dx: (Math.random() - 0.5) * (burst ? 160 : 60),
        rise: (burst ? 120 : 80) + Math.random() * 60,
        rot: (Math.random() - 0.5) * 70,
        size: burst ? 20 + Math.random() * 18 : 12 + Math.random() * 8,
        dur: burst ? 1.5 : 1.1,
        gold: burst ? true : Math.random() > 0.5,
      });
    }
    setNotes((prev) => [...prev.slice(-44), ...batch]);
  }, []);

  useEffect(() => {
    const onMove = (e) => {
      const now = performance.now();
      if (now - lastMove.current < 85) return;
      lastMove.current = now;
      spawn(e.clientX, e.clientY, false);
    };
    const onDown = (e) => spawn(e.clientX, e.clientY, true);
    window.addEventListener("pointermove", onMove, { passive: true });
    window.addEventListener("pointerdown", onDown, { passive: true });
    return () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerdown", onDown);
    };
  }, [spawn]);

  const remove = (id) => setNotes((prev) => prev.filter((n) => n.id !== id));

  return (
    <div
      data-testid="note-cursor-layer"
      className="pointer-events-none fixed inset-0 z-[70] overflow-hidden"
      aria-hidden="true"
    >
      <AnimatePresence>
        {notes.map((n) => (
          <motion.span
            key={n.id}
            initial={{ opacity: 0, x: n.x, y: n.y, scale: 0.3, rotate: 0 }}
            animate={{
              opacity: [0, 1, 1, 0],
              x: n.x + n.dx,
              y: n.y - n.rise,
              scale: 1,
              rotate: n.rot,
            }}
            transition={{ duration: n.dur, ease: "easeOut" }}
            onAnimationComplete={() => remove(n.id)}
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              fontSize: n.size,
              lineHeight: 1,
              color: n.gold ? "var(--gold)" : "var(--foreground-note, var(--fg))",
              textShadow: n.gold
                ? "0 0 10px rgba(212,175,55,0.55)"
                : "0 0 8px rgba(244,240,230,0.35)",
            }}
          >
            {n.symbol}
          </motion.span>
        ))}
      </AnimatePresence>
    </div>
  );
}
